export function getTeamSpecificThemeResults(aiThemesData: any, teamId?: number | string): any[] {
  if (!Array.isArray(aiThemesData) || aiThemesData.length === 0) {
    return [];
  }

  const themes = aiThemesData[0]?.result?.themes;
  if (!Array.isArray(themes)) {
    return [];
  }

  if (teamId == null) {
    return [];
  }

  return themes.filter((entry: any) => Number(entry?.team_id) === Number(teamId));
}
